import type { UserRuleMastery } from '@proref/types';
import { api, unwrap, type Envelope } from '../lib/api';

// The signed-in referee's full per-rule mastery distribution — every user_mastery row with its rule
// resolved, sorted by article number. Backs the Home rule-mastery radar + "drill these next" list
// (the /me/stats summary only exposes the single weakest rule). Scoped to the caller by their JWT.
export async function getMeMastery(): Promise<UserRuleMastery[]> {
  const res = await api.get<Envelope<UserRuleMastery[]>>('/me/mastery');
  return unwrap(res.data);
}
